import React from "react";
import { Clock } from "lucide-react";

const SimpleComingSoon: React.FC = () => (
  <div className="min-h-[40vh] flex flex-col items-center justify-center text-center py-16">
    <div className="bg-sauna-orange/10 rounded-full p-4 mb-4">
      <Clock className="text-sauna-orange" size={48} />
    </div>
    <h2 className="text-2xl md:text-3xl font-semibold text-sauna-navy mb-2">This feature is coming soon!</h2>
    <p className="text-lg text-sauna-navy/80 max-w-xl mx-auto">
      We're working hard to bring this to you. Stay tuned for updates!
    </p>
  </div>
);

export default SimpleComingSoon;
export { SimpleComingSoon };
